import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

function UrlTabs({ value, onChange, tabs, sx }) {
  return (
    <Tabs value={value} onChange={(_, v) => onChange(v)} variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile sx={sx}>
      {tabs.map(({ value: tabValue, label }) => (
        <Tab key={tabValue} value={tabValue} label={label} />
      ))}
    </Tabs>
  );
}

export default UrlTabs;
